import React from 'react'
import { pure } from 'recompose';
import { Link, withRouter } from 'react-router-dom'
import { Card, CardImage, Image, CardContent, CardHeader } from 'modules/common/components/ui/Card'
import withLocalized from 'modules/localization/withLocalized'

const ProCard = (props) => {
  let {
    display_name = '',
    city = '',
    machine_name,
    profile_banner = [],
    picture = [],
    default_course = [],
    fluid = false,
    onMouseOver = () => {},
    onMouseOut = () => {},
    activeOnHover = false,
    active = false,
    noLazyload = false,
    showArea = false,
    area = [],
    localized,
  } = props;

  const imageSrc = picture instanceof Array && picture.length > 0 ? picture[0].formatted_large : (profile_banner instanceof Array && profile_banner.length > 0 ? profile_banner[0].formatted_large : undefined);

  const linkProps = {
    pathname: `/pros/${machine_name}`,
    state: { backLink: props.location.pathname + props.location.search }
  };

  
  const course = default_course.length > 0 ? default_course[0].label : undefined
  
  let courseString = '';
  if(course){
    courseString = course
  }
  if(city){
    if(course){
      courseString = `${courseString}, ${city}`
    }
    else{
      courseString = city
    }
  }
  
  return (
    <Card fluid={fluid} activeOnHover={activeOnHover} active={active} onMouseOver={event => onMouseOver(props)} onMouseOut={onMouseOut}>
      <Link to={ linkProps }>
        {noLazyload && <Image src={ imageSrc } />}
        {!noLazyload && <CardImage src={ imageSrc } />}
      </Link>
      <CardContent>
        <CardHeader>
          <Link to={ linkProps }>{ display_name }</Link>
        </CardHeader>
        <Link to={ linkProps }>
          { courseString }
        </Link>
        { showArea && area.length && area[0].label !== 'finland' ? <span className="pro--area">, {localized(`areaselect.areas.${area[0].label}`)}</span> : null }
      </CardContent>
    </Card>
  )
};

export default pure(withRouter(withLocalized(ProCard)));



// WEBPACK FOOTER //
// ./src/modules/pros/components/ProCard.js